import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { PresaveCampaignStats } from '../../../redux/api/fymAPI.types';
import { PresaveCounterCard } from './PresaveCounterCard';
import { PresaveSparkBars } from './PresaveSparkBars';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole panel; each part uses its own slice of it */
import styles from './PresavePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PresaveEmailsCardProps {
  stats: PresaveCampaignStats;
}

/**
 * The fans who left an address instead of connecting a service. The note under
 * the figure says what that address is actually for — the old panel counted
 * them and never explained them.
 */
const PresaveEmailsCardComponent: React.FC<PresaveEmailsCardProps> = ({ stats }) => {
  const intl = useIntl();

  return (
    <PresaveCounterCard
      label={intl.formatMessage({ id: 'app.sml.presave.panel.emails', defaultMessage: 'Email reminders' })}
      value={intl.formatNumber(stats.emailCount)}
      unit={intl.formatMessage({ id: 'app.sml.presave.panel.emails.unit', defaultMessage: 'collected' })}
      delta={
        stats.emailTodayCount > 0
          ? intl.formatMessage(
              { id: 'app.sml.presave.panel.today', defaultMessage: '+{count} today' },
              { count: intl.formatNumber(stats.emailTodayCount) }
            )
          : '—'
      }
      deltaIsPositive={stats.emailTodayCount > 0}
    >
      <PresaveSparkBars series={stats.emailDailySeries} />
      <p className={styles.cardNote}>
        {intl.formatMessage({
          id: 'app.sml.presave.panel.emails.note',
          defaultMessage:
            'Fans who chose a reminder instead of a service. They each get one email when you mark the release out.',
        })}
        {stats.optInNewsCount > 0 && (
          <>
            {' '}
            {intl.formatMessage(
              {
                id: 'app.sml.presave.panel.emails.opt_in',
                defaultMessage: '{count} also opted into artist news.',
              },
              { count: intl.formatNumber(stats.optInNewsCount) }
            )}
          </>
        )}
      </p>
    </PresaveCounterCard>
  );
};

export const PresaveEmailsCard = TypedMemo(PresaveEmailsCardComponent);
